// src/data/thesisData.js
// Election + macro theses, hydrated live from the Go thesis API (no mock data).
import { useEffect, useState } from "react";

export const THESIS_API = process.env.REACT_APP_THESIS_API_URL || "/api/thesis";

// Mutable container. We MUTATE these arrays in place (push) instead of
// reassigning, so existing `import { ELECTION_CLUSTERS }` references stay valid
// after the fetch resolves — reassigning a `let` export does not propagate to
// already-imported consumers, but mutating the same array object does.
export const ELECTION_CLUSTERS = [];
export const GLOBAL_MACRO_THESES = [];

const subscribers = new Set();
let _loaded = false;
let _loading = false;

async function loadTheses() {
  if (_loading || _loaded) return;
  _loading = true;
  try {
    const res = await fetch(`${THESIS_API}/rr/v1/thesis`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    const withHero = data.map((b) => ({ ...b, isHero: b.id === "hero_main" }));

    // Mutate in place.
    ELECTION_CLUSTERS.length = 0;
    GLOBAL_MACRO_THESES.length = 0;
    withHero.forEach((b) => {
      if (b.cluster_id === "eleicoes-2026") ELECTION_CLUSTERS.push(b);
      else if (b.cluster_id === "macro-global") GLOBAL_MACRO_THESES.push(b);
    });

    _loaded = true;
    subscribers.forEach((cb) => cb());
  } catch (e) {
    console.error("[thesisData] failed to load theses:", e);
  } finally {
    _loading = false;
  }
}

loadTheses();

// Call this in any component that renders the arrays, so it re-renders once the
// data arrives. Returns the live arrays + a `loaded` flag.
export function useTheses() {
  const [, force] = useState(0);
  useEffect(() => {
    const cb = () => force((n) => n + 1);
    subscribers.add(cb);
    if (!_loaded) loadTheses();
    else force((n) => n + 1);
    return () => subscribers.delete(cb);
  }, []);
  return { electionClusters: ELECTION_CLUSTERS, macroTheses: GLOBAL_MACRO_THESES, loaded: _loaded };
}